/**
 * Created by Ning Jiang on 2021-05-04.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {GameModelEvent} from "@nolimitcity/slot-game/bin/model/GameModel";
import {LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {KarenGameAssets} from "./KarenGameAssets";
import {KarenSoundManager} from "./sound/KarenSoundManager";
import {KarenBackground} from "./view/KarenBackground";
import {KarenWinPresentation} from "./gameflow/KarenWinPresentation";
import {KarenNormalBetPresentation} from "./gameflow/KarenNormalBetPresentation";
import {KarenNormalResultPresentation} from "./gameflow/KarenNormalResultPresentation";
import {KarenNormalIdlePresentation} from "./gameflow/KarenNormalIdlePresentation";
import {KarenZeroBetIdlePresentation} from "./gameflow/KarenZeroBetIdlePresentation";
import {IKarenGameData, IKarenInitData} from "./server/data/IKarenData";
import {KarenModel} from "./server/KarenModel";
import {KarenLayers} from "./view/KarenLayers";
import {KarenReelController} from "./reels/KarenReelController";
import {KarenGameConfig} from "./KarenGameConfig";
import {ReelStopPresentationManager} from "./reelstoppresentation/ReelStopPresentationManager";
import {ReelStopSoundController} from "./reelstoppresentation/presentations/ReelStopSoundController";
import {WinPresentationManager} from "./winpresentation/WinPresentationManager";
import {WildLandingController} from "./reelstoppresentation/presentations/WildLandingController";
import {ScatterLandingController} from "./reelstoppresentation/presentations/ScatterLandingController";
import {InitialWinCountUp} from "./winpresentation/presentations/initial/InitialWinCountUp";
import {BigWinCountUp} from "./winpresentation/presentations/bigwin/BigWinCountUp";
import {BigWinController} from "./winpresentation/presentations/bigwin/BigWinController";
import {WildNudgeController} from "./winpresentation/presentations/WildNudgeController";
import {InitialWinController} from "./winpresentation/presentations/initial/InitialWinController";
import {NoWinSymbolsController} from "./winpresentation/presentations/NoWinSymbolsController";
import {IndividualWinController} from "./winpresentation/individual/IndividualWinController";
import {FreespinIntro} from "./screen/FreespinIntro";
import {KarenFreespinIdlePresentation} from "./gameflow/KarenFreespinIdlePresentation";
import {FreespinWinController} from "./winpresentation/presentations/FreespinWinController";
import {FreespinOutro} from "./screen/FreespinOutro";
import {FreespinEndController} from "./winpresentation/presentations/FreespinEndController";
import {WinCapScreen} from "./screen/WinCapScreen";
import {BreakBankController} from "./winpresentation/presentations/BreakBankController";
import {XWController} from "./winpresentation/presentations/XWController";
import {KarenStickyXWView} from "./view/KarenStickyXWView";
import {Reel2Frame} from "./view/Reel2Frame";
import {CustomWiggle} from "gsap/dist/CustomWiggle";
import {CustomBounce} from "gsap/dist/CustomBounce";
import {Linear} from "gsap";
import {KarenMiniPayble} from "./view/KarenMiniPayble";
import {ReelNearWinController} from "./reelstoppresentation/presentations/ReelNearWinController";
import {Translator} from "../core/config/translate/Translator";
import {KarenReelBackground} from "./view/KarenReelBackground";
import {KarenSoundConfig} from "./sound/KarenSoundConfig";
import {KarenIntroView} from "./intro/KarenIntroView";
import {SpinePlayer} from "../core/displayObject/SpinePlayer";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {KarenReelExpandOverlayView} from "./view/KarenReelExpandOverlayView";
import {KarenMultiplierWaysTextView} from "./view/KarenMultiplierWaysTextView";
import {BillBoardController} from "./winpresentation/presentations/BillBoardController";
import {GameHelper} from "../core/utils/GameHelper";
import {KarenBilBoardAnimationView} from "./view/KarenBilBoardAnimationView";
import {KarenSplashOverlayView} from "./view/KarenSplashOverlayView";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {BetFeature} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";
import {KarenGameMode} from "./server/KarenGameMode";
import {Skinner} from "@nolimitcity/slot-launcher/bin/utils/Skinner";

export class Karen extends SlotGame {
    public static isActionSpinsActive: boolean = false;
    public static model: KarenModel;
    public static gameFlowController: GameFlowController;
    public static assetLoader: AssetLoader;
    public static reels: KarenReelController[];
    public static reelStopPresentations: ReelStopPresentationManager;
    public static winPresentations: WinPresentationManager;
    public static initialCountUp: InitialWinCountUp;
    public static bigWinCountUp: BigWinCountUp;
    public static individualWin: IndividualWinController;
    public static freespinIntro: FreespinIntro;
    public static freespinOutro: FreespinOutro;
    public static winCapScreen: WinCapScreen;
    public static bigWinController: BigWinController;
    public static background: KarenBackground;
    public static stickyXWView: KarenStickyXWView;
    public static initReels: string[][];
    public static reel2Frame: Reel2Frame;
    public static miniPaytable: KarenMiniPayble;
    public static translate: Translator;
    public static reelBackground: KarenReelBackground;
    public static introView: KarenIntroView;
    public static normalIdle: KarenNormalIdlePresentation;
    public static reelExpandOverlayView: KarenReelExpandOverlayView;
    public static xwaysMultiplierView: KarenMultiplierWaysTextView;
    public static billBoardAnimation: KarenBilBoardAnimationView;
    public static splashView: KarenSplashOverlayView;

    public static xWShakeWiggle: any = CustomWiggle.create("xWShakeWiggle", {
        wiggles: 8,
        type: "easeOut",
        amplitudeEase: Linear.easeNone,
        timingEase: Linear.easeNone,
    });

    public static StageShakeBounce: any = CustomBounce.create("shakeBounce", {
        strength: 0.8,
        squash: 1,
        endAtStart: true,
        squashID: "shake"
    });

    public static ScatterBounceWiggle: any = CustomBounce.create("shakeBounce", {
        strength: 0.5,
        squash: 3,
        endAtStart: true,
        squashID: "shake"
    });
    public static skinner:Skinner;
    constructor() {
        super();
        const validSkins:string[] = [
            "sweep"
        ]
        Karen.skinner = new Skinner(validSkins);
    }

    private handleSweepInit(){
        //Making sure that skinID is set based  on "replaceWordFree" gcc.
        if (SlotGame.apiPlugin.gameClientConfiguration.isSet) {
            if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                Karen.skinner.skinId = "sweep";
            }
        } else {
            SlotGame.apiPlugin.events.on(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                    Karen.skinner.skinId = "sweep";
                }
            })
        }
    }

    private handleSweepGetReady() : Promise<any>{
        if (Karen.skinner.skinId != undefined) {
            const replaceMap:Map<string, string> = new Map();
            //Bonus
            replaceMap.set("BOOSTED_BET", "BOOSTED_BET.png");
            replaceMap.set("reel2button/Sign_off_active", "xplay_off_active.png");
            replaceMap.set("reel2button/Sign_on_active", "xplay_on_active.png");
            return Karen.skinner.loadSkin(replaceMap);
        }
        return Promise.resolve();
    }

    public async init(): Promise<NolimitPlugin> {
        const value: NolimitPlugin = await super.init();

        KarenGameConfig.updateReelSets();
        Karen.model = new KarenModel(SlotGame.apiPlugin, true);
        Karen.gameFlowController = new GameFlowController(SlotGame.apiPlugin, Karen.model);
        Karen.gameFlowController.flowStateLogger.level = LogLevel.DEV;
        Karen.translate = new Translator(Karen.apiPlugin.translations.translate);
        //Example
        Karen.model.events?.on(GameModelEvent.GAME, (data: IKarenGameData) => {
        });
        const idleNormal: KarenNormalIdlePresentation = new KarenNormalIdlePresentation();
        const reelStart: FlowStatePresentation = new KarenNormalBetPresentation();
        const normalResult: FlowStatePresentation = new KarenNormalResultPresentation();
        const freespinIdle: FlowStatePresentation = new KarenFreespinIdlePresentation();
        const zeroBetIdle: FlowStatePresentation = new KarenZeroBetIdlePresentation();
        const winPres: FlowStatePresentation = new KarenWinPresentation();
        Karen.normalIdle = idleNormal;

        Karen.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, idleNormal],
            [FlowState.BET, reelStart],
            [FlowState.RESULT, normalResult],
            [FlowState.WIN, winPres]
        ]));
        Karen.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.FREESPIN, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, freespinIdle],
            [FlowState.BET, reelStart],
            [FlowState.RESULT, normalResult],
            [FlowState.WIN, winPres]
        ]));

        Karen.apiPlugin.events.on(APIEvent.SELECTED_FEATURE_BET_CHANGED, (data: any) => {
            let featureData: BetFeature | undefined = Karen.apiPlugin.betFeatureController.getActiveBetFeature();
            if(Karen.reel2Frame){
                if (featureData) {
                    if (featureData?.name === "BOOSTED_BET") {
                        Karen.reel2Frame.updateLayout(1, true);
                    } else if (featureData?.name !== "BOOSTED_BET") {
                        Karen.reel2Frame.updateLayout(0, false);
                    }
                } else {
                    Karen.reel2Frame.updateLayout(0, false);
                }
            }
        });

        this.handleSweepInit();
        return value;
    }

    public async getReady(): Promise<NolimitPlugin> {
        //Show intro and load game assets
        const value: NolimitPlugin = await super.getReady();

        const fontLoader = new FontLoader(NolimitApplication.resourcePath);
        fontLoader.add(OpenSans.ITALIC_600);
        fontLoader.add(OpenSans.NORMAL_300);
        fontLoader.add(OpenSans.NORMAL_400);
        fontLoader.add(OpenSans.NORMAL_700);
        fontLoader.add({
            family: "Impact",
            weight: FontWeight.BLACK,
            style: FontStyle.NORMAL,
            url: "/resources/fonts/Impact.woff"
        });

        AssetsConfig.addToAssetsConfig(KarenGameAssets.RESOURCES_GROUPS);
        Karen.assetLoader = new AssetLoader(Karen.apiPlugin, NolimitApplication.resourcePath + "/resources/");

        await Promise.all([fontLoader.load(), Karen.assetLoader.load(ResourcesGroupName.MAIN)]);
        await this.handleSweepGetReady();
        await this.createViewsAndComponents();
        return value;
    }

    public async getReadyToStart(): Promise<NolimitPlugin> {
        //Game assets loaded, showing intro, waiting for user to start game.
        KarenSoundManager.switchMusic(
            {name: KarenSoundConfig.MAIN_GAME_MUSIC, volume: 0},
            {name: KarenSoundConfig.MAIN_GAME_MUSIC, from: 0, to: 1, duration: 1000}
        );

        return await super.getReadyToStart();
    }

    public async start(): Promise<NolimitPlugin> {
        //User has pressed continue and the game starts.

        const value: NolimitPlugin = await super.start();

        Karen.gameFlowController.start();



        return value;
    }

    getNoWinGameData(): any {
        return {
            "reels": [
                [
                    "L1",
                    "L5",
                    "L2",
                    "M5"
                ],
                [
                    "L1",
                    "M3",
                    "M1",
                    "L4",
                    "XW"
                ],
                [
                    "M4",
                    "M1",
                    "M4",
                    "L3",
                    "L2",
                    "L1"
                ],
                [
                    "M3",
                    "L3",
                    "L5",
                    "M5",
                    "XW",
                    "L1",
                    "L1"
                ],
                [
                    "S",
                    "M4",
                    "M2",
                    "L5",
                    "M4",
                    "L1",
                    "L1",
                    "L1"
                ],
                [
                    "L4",
                    "L1",
                    "L5",
                    "M2",
                    "M2",
                    "L1",
                    "L1",
                    "L1",
                    "L1"
                ]
            ],
            "evaluatedArea": [
                [
                    "L5",
                    "L2"
                ],
                [
                    "M3",
                    "M1",
                    "L4"
                ],
                [
                    "M1",
                    "M4",
                    "L3"
                ],
                [
                    "L3",
                    "L5",
                    "M5"
                ],
                [
                    "M4",
                    "M2",
                    "L5"
                ],
                [
                    "L1",
                    "L5",
                    "M2"
                ]
            ],
            "betWayWins": [],
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 10,
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "numberOfFreespinsPlayed": 0,
            "freespinsLeft": 0,
            "freespinTriggeredThisSpin": false,
            "symbolSizes": [
                [
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1
                ]
            ],
            "wasFeatureBuy": false,
            "currentMultiplier": 1,
            "brokeTheBank": false,
            "initialAreaSize": [
                2,
                3,
                3,
                3,
                3,
                3
            ],
            "mysterySymbolReveal": "",
            "stickyXWaysFSPositions": {},
            "fsXWaysSizeBefore": 2,
            "boostedBetPlayed": false
        };
    }

    private createViewsAndComponents() {
        //Non views
        const sound: KarenSoundManager = new KarenSoundManager();
        const layers: KarenLayers = new KarenLayers();
        if (SpinePlayer) SpinePlayer.setSpineLoader(Karen.assetLoader);
        //Views
        Karen.background = new KarenBackground();
        Karen.reel2Frame = new Reel2Frame();
        Karen.stickyXWView = new KarenStickyXWView();
        Karen.billBoardAnimation = new KarenBilBoardAnimationView();
        Karen.initialCountUp = new InitialWinCountUp();
        Karen.bigWinCountUp = new BigWinCountUp();
        Karen.freespinIntro = new FreespinIntro();
        Karen.freespinOutro = new FreespinOutro();
        Karen.winCapScreen = new WinCapScreen();
        Karen.reelBackground = new KarenReelBackground();
        Karen.introView = new KarenIntroView();
        Karen.reelExpandOverlayView = new KarenReelExpandOverlayView();
        Karen.xwaysMultiplierView = new KarenMultiplierWaysTextView();
        Karen.splashView = new KarenSplashOverlayView();

        Karen.miniPaytable = new KarenMiniPayble((Karen.model.initData as IKarenInitData).symbolValues, {showBetValue: true});
        Karen.reels = [];
        for (let i: number = 0; i < KarenGameConfig.REELS_NUM; i++) {
            const reel = new KarenReelController(i);
            Karen.reels.push(reel);
        }
        Karen.reelStopPresentations = new ReelStopPresentationManager([
            new ReelStopSoundController(),
            new ReelNearWinController(),
            new WildLandingController(),
            new ScatterLandingController()
        ]);
        Karen.winPresentations = new WinPresentationManager([
            new WildNudgeController(),
            new XWController(),
            new NoWinSymbolsController(),
            new InitialWinController(),
            Karen.bigWinController = new BigWinController(),
            new FreespinWinController(),
            new FreespinEndController(),
            new BillBoardController(),
            new BreakBankController(),
        ]);
        Karen.individualWin = new IndividualWinController();

        if (Karen.model.isRestore && Karen.model.parsedInitData.showTotalWin) {
            SlotGame.keypadPlugin.setWin(Karen.model.parsedInitData.totalWin, true, GameHelper.isWinBelowStake());
        }
        Karen.apiPlugin.events.on(APIEvent.ACTION_SPINS_IS_ACTIVE, (data: any) => {
            if (data === true) {
                Karen.isActionSpinsActive = true;
                if (Karen.model.gameData) {
                    Karen.individualWin.stop();
                    Karen.initialCountUp.remove().progress(1);
                    Karen.bigWinCountUp.remove().progress(1);
                }
            } else {
                Karen.isActionSpinsActive = false;
            }
            let featureData: BetFeature | undefined = Karen.apiPlugin.betFeatureController.getActiveBetFeature();
            if(featureData?.name!==KarenGameMode.FREESPIN && featureData?.name!==KarenGameMode.FREESPIN_SUPER && featureData?.name!=="LUCKY_DRAW") {
                if (SlotGame.apiPlugin.betHandler.betBoost !== undefined) {
                    Karen.reel2Frame.updateLayout(1, false);
                } else {
                    Karen.reel2Frame.updateLayout(0, false);
                }
            }
        });
        // If restore, can be handled in these constructors directly.
    }
}
